export enum EventContentTabs {
  VIDEO = 'video',
  POSTER = 'poster',
  ABSTRACT = 'abstract',
  QUESTIONS = 'questions',
  VOTING = 'voting',
}
